import React, { useState, useEffect } from 'react';
import { Container, Table, Button, Form, Card, InputGroup, Spinner } from 'react-bootstrap';
import { apiFetch } from '../../../utils/api.js';

export function AdminCategories() {
  const [categories, setCategories] = useState([]);
  const [newName, setNewName] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchCats = async () => {
    setLoading(true);
    try {
      const res = await apiFetch('/api/categories');
      const data = await res.json();
      setCategories(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchCats(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;

    const data = new FormData();
    data.append('name', newName);

    const res = await apiFetch('/api/categories', { method: 'POST', body: data });
    if (res.ok) {
      setNewName('');
      fetchCats();
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Удалить категорию? Услуги, привязанные к ней, не удалятся, но останутся без категории.")) {
      await apiFetch(`/api/categories/${id}`, { method: 'DELETE' });
      fetchCats();
    }
  };

  return (
    <Container>
      <div className="mb-4">
        <h2 className="fw-bold">Категории работ</h2>
        <p className="text-muted">Создайте группы для ваших услуг, чтобы клиентам было проще их искать.</p>
      </div>

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body className="p-4">
          <Form onSubmit={handleAdd}>
            <Form.Label className="small fw-bold text-uppercase text-muted">Добавить новую</Form.Label>
            <InputGroup size="lg">
              <Form.Control 
                placeholder="Например: Укладка брусчатки" 
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                className="bg-light border-0"
              />
              <Button type="submit" className="btn-corp px-4">
                <i className="bi bi-plus-lg me-2"></i>Добавить
              </Button>
            </InputGroup>
          </Form>
        </Card.Body>
      </Card>

      <Card className="border-0 shadow-sm">
        <Card.Body className="p-0">
          {loading ? (
            <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div>
          ) : (
            <Table hover responsive className="m-0">
              <thead className="bg-light">
                <tr>
                  <th className="px-4 py-3 border-0">Название категории</th>
                  <th className="px-4 py-3 border-0 text-end">Действие</th>
                </tr>
              </thead>
              <tbody>
                {categories.map(cat => (
                  <tr key={cat.id}>
                    <td className="px-4 py-3 align-middle fw-semibold">{cat.name}</td>
                    <td className="px-4 py-3 text-end">
                      <Button variant="outline-danger" size="sm" className="border-0" onClick={() => handleDelete(cat.id)}>
                        <i className="bi bi-trash3 fs-5"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
                {categories.length === 0 && (
                  <tr>
                    <td colSpan="2" className="text-center py-5 text-muted">Список категорий пока пуст</td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
}
